import ElementContent from '@/components/sections/builder/elements/body/multicolumn/content';
import ElementSetting from '@/components/sections/builder/elements/body/multicolumn/setting';
import Column from '@/components/sections/builder/elements/body/multicolumn/column';
import { ElementDataType } from '@/components/sections/builder/elements/body/multicolumn/type';
import { Columns3 } from 'lucide-react';
import { DEFAULT_THEME_COLOR_SCHEME } from '@/components/sections/builder/theme/color';

const defaultData: ElementDataType = {
  name: 'Multicolumn',
  heading: 'Multicolumn',
  headingSize: '30',
  imageWidth: 'medium',
  imageRatio: 'circle',
  numberOfColumns: 3,
  columnAlignment: 'left',
  secondaryBackground: 'background1',
  buttonLabel: 'Button label',
  buttonLink: '',
  imagePosition: 'left',
  padding: {
    top: 20,
    bottom: 20,
    left: 20,
    right: 20,
  },
  contentAlign: 'center',
  titleAlign: 'center',
  buttonRadius: 5,
  colorScheme: DEFAULT_THEME_COLOR_SCHEME,
  secondaryBgColor: {
    color: '#ffffff',
    opacity: 100,
  },
  dekstopContentHeadingFontSize: 'base',
  dekstopContentDescriptionFontSize: 'xs',
  mobileContentHeadingFontSize: 'base',
  mobileContentDescriptionFontSize: 'xs',
};

export const ElementPreviewIcon = Columns3;

const Multicolumn = {
  type: 'multicolumn',
  group: 'body',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
  defaultChilds: [Column, Column, Column],
  childs: [Column],
};

export default Multicolumn;
